
<div class="row">
    <div class="view-screen">
        <div class="row">
        <div class="col-5" style="margin-bottom: 10px;">
            <table class="table">
                <tr>
                    <td class="label-col text-right" style="width:200px;">Numer seryjny:</td>
                    <td style="width:200px;">
                        <p class="info">{{ rekbot.serial_no }}</p>
                    </td>
                    <td></td>
                </tr>
                <tr>
                    <td class="label-col text-right">Status:</td>
                    <td>
                        <p class="info">{{ rekbot.namedStatus }}</p>
                    </td>
                    <td></td>
                </tr>
                <tr>
                    <td class="label-col text-right">Ostatnia synchronizacja:</td>
                    <td>
                        <p class="info">{{ rekbot.last_synced_at }}</p>
                    </td>
                    <td></td>
                </tr>
                <tr>
                    <td class="label-col text-right">IP:</td>
                    <td>
                        <p class="info">{{ rekbot.ipv4 }}</p>
                    </td>
                    <td></td>
                </tr>
                <tr>
                    <td class="label-col text-right">Port:</td>
                    <td>
                        <p class="info">{{ rekbot.port }}</p>
                    </td>
                    <td></td>
                </tr>
                <tr>
                    <td class="label-col text-right">GPS device ID:</td>
                    <td>
                        <p class="info">{{ rekbot.gps_device_id }}</p>
                    </td>
                    <td></td>
                </tr>
            </table>
        </div>
        <div class="col-4" style="margin-bottom: 10px;" *ngIf="userPermission >= ROLES.admin">
            <table class="table">
                <tr>
                    <td class="label-col text-right p-3">Restart Aplikacji: </td>
                    <td>
                        <button mat-mini-fab color="accent" matTooltip="Restart Application"
                            (click)="restartApplication(rekbot)">
                            <mat-icon fontIcon="restart_alt"></mat-icon>
                        </button>
                    </td>
                    <td>
                        <p class="info">{{ rekbot.restart_application }}</p>
                    </td>
                </tr>
                <tr>
                    <td class="label-col text-right p-3">Restart Api: </td>
                    <td>
                        <button mat-mini-fab type="button" matTooltip="Restart Api" (click)="restartApi(rekbot)">
                            <mat-icon aria-hidden="false" aria-label="restartApi"
                                fontIcon="restart_alt"></mat-icon>
                        </button>

                    </td>
                    <td>
                        <p class="info">{{ rekbot.restart_api }}</p>
                    </td>
                </tr>
                <tr>
                    <td class="label-col text-right p-3">Restart PLC: </td>
                    <td>
                        <button mat-mini-fab type="button" matTooltip="Restart PLC" (click)="restartPlc(rekbot)">
                            <mat-icon aria-hidden="false" aria-label="restartPlc"
                                fontIcon="restart_alt"></mat-icon>
                        </button>
                    </td>
                    <td>
                        <p class="info">{{ rekbot.restart_plc }}</p>
                    </td>
                </tr>
                <tr>
                    <td class="label-col text-right p-3">Restart PC: </td>
                    <td >
                        <button mat-mini-fab type="button" matTooltip="Restart PC" (click)="restartPc(rekbot)">
                            <mat-icon aria-hidden="false" aria-label="restartPC"
                                fontIcon="restart_alt"></mat-icon>
                        </button>

                    </td>
                    <td>
                        <p class="info">{{ rekbot.restart_pc }}</p>
                    </td>
                </tr>
            </table>
        </div>
    </div>
    <button mat-flat-button (click)="onChangeProdStatus()" *ngIf="!isChangingProdStatus && userPermission >= ROLES.admin">Zmień status produkcji</button>

    <mat-button-toggle-group name="fontStyle" aria-label="Font Style" [formControl]="selectedStatus" *ngIf="isChangingProdStatus" (change)="onChangeProdStatus()">
                <mat-button-toggle [value]="-1">Anuluj</mat-button-toggle>
                <mat-button-toggle [value]="2">Klient</mat-button-toggle>
                <mat-button-toggle [value]="1">Montaż</mat-button-toggle>
                <mat-button-toggle [value]="0">Magazyn</mat-button-toggle>
    </mat-button-toggle-group>

    </div>
    <hr>
    <div class="d-flex flex-row">
        <div >
            <h3>Log Rekbot-a</h3> 
        </div>
        <div class="d-flex flex-fill justify-content-end">
            <button mat-flat-button color="accent" (click)="fetchLogFromRekbot()">Odśwież Logi Rekbot-a</button>
        </div>
    </div>

    <div fxLayoutAlign="center center">
        <mat-form-field fxFlex="40%">
            <input matInput type="text" (keyup)="doFilter($event)" placeholder="Filtruj">
        </mat-form-field>
    </div>

    <div *ngIf="isLoading">
        <mat-progress-bar mode="query"></mat-progress-bar>
    </div>
    <div style="height:4px;" *ngIf="!isLoading">
    </div>
    <mat-tab-group [selectedIndex]="2">
        <mat-tab label="Status">
            <app-rekbot-status/>
        </mat-tab>
        <mat-tab label="Logi">
            <table mat-table matSort [dataSource]="dataSource" class="common-table">

                <!-- Position Column -->
                <ng-container matColumnDef="id">
                    <th style="width:50px;" mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
                    <td mat-cell *matCellDef="let element"> {{element.id}} </td>
                </ng-container>

                <!-- serial_no Column -->
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> STATUS </th>
                    <td mat-cell *matCellDef="let element"> {{element.status}} </td>
                </ng-container>

                <!-- IP Column -->
                <ng-container matColumnDef="message">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> KOMUNIKAT </th>
                    <td mat-cell *matCellDef="let element"> {{element.message}} </td>
                </ng-container>


                <!-- Symbol Column -->
                <ng-container matColumnDef="rekbot_created_at">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> DATA REKBOT-A</th>
                    <td mat-cell *matCellDef="let element"> {{ element.rekbot_created_at }}
                    </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="created_at">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> DATA OPERACJI</th>
                    <td mat-cell *matCellDef="let element"> {{ element.created_at | date:'YYYY-MM-dd HH:mm'}}
                    </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-paginator #paginator [length]="totalData" [pageSizeOptions]="pageSizes"
                (page)="pageChanged($event)" showFirstLastButtons aria-label="Wybierz stronę">
            </mat-paginator>
        </mat-tab>
    </mat-tab-group>
    
    <br>
</div>
        
<!-- 


    <ng-template #editModal let-modal>
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">Edytuj Rekbot-a</h4>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                (click)="modal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body">
            <form [formGroup]="editForm">
                <input type="hidden" id="id" name="id" formControlName="id">

                <div class="form-group">
                    <label for="serial_no">Numer seryjny</label>
                    <div class="input-group">
                        <input id="serial_no" name="serial_no" class="form-control" placeholder=""
                            formControlName="serial_no">
                    </div>
                </div>
                <div class="form-group">
                    <label for="ipv4">Adres IP </label>
                    <div class="input-group">
                        <input id="ipv4" name="ipv4" class="form-control" placeholder="" formControlName="ipv4">
                    </div>
                </div>
                <div class="form-group">
                    <label for="port">Port</label>
                    <div class="input-group">
                        <input id="port" name="port" class="form-control" placeholder="" formControlName="port">
                    </div>
                </div>
            </form>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-danger" (click)="modal.close('Save click');">Anuluj</button>
            <button type="button" class="btn btn-outline-dark"
                (click)="onSubmitRekbot();modal.close('Save click');">Zapisz</button>
        </div>
    </ng-template> -->
